import { createFileRoute, Navigate } from '@tanstack/react-router';
import { pageTitle, usePageTitle } from '@/utils/pageTitle';
import { SupplierTable } from '@/components/Pages/Suppliers/SupplierTable';
import { CreateEditSupplierModal } from '@/components/Pages/Suppliers/CreateEditSupplierModal';
import { Box } from '@mui/joy';
import { useAuth } from '@/contexts/AuthContext';

export const Route = createFileRoute('/_protected/suppliers/')({
  component: SuppliersPage,
  head: () => pageTitle('Proveedores'),
});

function SuppliersPage() {
  usePageTitle('Proveedores');
  const { hasClaim, isLoading } = useAuth();
  const canRead = hasClaim('SUPPLIERS_READ');
  const canWrite = hasClaim('SUPPLIERS_WRITE');

  if (!isLoading && !canRead) {
    return <Navigate to='/' />;
  }

  return (
    <Box>
      {canWrite && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
          <CreateEditSupplierModal />
        </Box>
      )}
      <SupplierTable />
    </Box>
  );
}
